export default {
  brand: {
    name: 'VILLAGARAGE',
    tagline: 'Premium Garage Systems',
  },
  nav: {
    home: 'Accueil',
    garage: 'Systèmes de garage',
    villa: 'Projets de villa',
    winter: "Jardin d'hiver",
    projects: 'Projets',
    about: 'À propos',
    contact: 'Contact',
    dealer: 'Partenariat & Concession',
    login: 'Espace Membre / Revendeur',
    cta: 'Demander un devis pour votre projet',
  },
  hero: {
    title1: 'Systèmes de garage premium',
    title2: 'qui valorisent votre villa',
    subtitle: 'Solutions de garage fermé premium, conçues sur mesure pour les projets de villa de luxe et les villas privées.',
    cta1: 'Demander un devis pour votre projet',
    cta2: 'Découvrir les systèmes de garage',
    small: 'Systèmes 1 & 2 véhicules • Design architectural sur mesure • Solutions par projet',
  },
  s1: {
    title: 'Un garage ne doit pas être un ajout tardif à votre villa.',
    text: 'VILLAGARAGE considère le garage non comme une structure indépendante, mais comme une partie intégrante de l’architecture de la villa.',
    f1: 'Design architectural sur mesure',
    f2: 'Apparence premium',
    f3: 'Protection du véhicule en toutes saisons',
  },
  s2: {
    title: 'Même villa. Un niveau de vie différent.',
    openTitle: 'Stationnement ouvert',
    openDesc: 'Véhicule exposé aux intempéries. Manque d’unité architecturale. N’apporte aucune valeur au projet.',
    garageTitle: 'Garage premium VILLAGARAGE',
    garageDesc: 'Véhicule protégé toute l’année. S’intègre à l’architecture de la villa. Apporte une valeur premium au projet.',
    cta: 'Demander une solution pour votre projet',
  },
  s3: {
    title: 'Systèmes de garage',
    cta: 'Découvrir',
    card1: {
      title: 'Garage premium une place',
      desc: 'Un garage premium compact, élégant et architecturalement sur mesure pour un seul véhicule.',
    },
    card2: {
      title: 'Garage premium deux places',
      desc: 'Un garage premium spacieux et lumineux qui s’intègre parfaitement à votre villa pour deux véhicules.',
    },
    card3: {
      title: 'Systèmes de garage sur mesure',
      desc: 'Des solutions sur mesure conçues pour les projets de villa et les exigences spécifiques.',
    },
  },
  s4: {
    title1: 'Aucune villa n’est identique.',
    title2: 'Leur garage non plus.',
    d1: 'Systèmes architecturaux anthracite',
    d2: 'Détails en bois naturel',
    d3: 'Éclairage architectural',
    d4: 'Designs de façade personnalisés',
    d5: 'Solutions 1 & 2 véhicules',
  },
  s5: {
    title: 'Un détail qui distingue les projets de villa',
    subtitle: 'VILLAGARAGE pour les entreprises de construction, les promoteurs et les architectes.',
    b1: 'Design par projet',
    b2: 'Intégration à l’architecture de la villa',
    b3: 'Structure adaptée aux projets multi-villas',
    b4: 'Perception premium du projet',
    b5: 'Solutions une / deux places',
    b6: 'Une approche systémique alternative aux procédés de construction lourds traditionnels',
    cta: 'Soumettre votre projet de villa',
  },
  s6: {
    title: 'Ne laissez pas votre voiture de luxe exposée toute l’année.',
    text: 'Créez un espace premium mieux protégé contre le soleil, la pluie, la grêle, la neige et les facteurs extérieurs.',
    cta: 'Je veux un garage pour ma villa',
  },
  s7: {
    title: 'Solutions architecturales holistiques pour votre villa',
    subtitle: "Garage premium + Jardin d'hiver",
    cta: 'Demander des informations pour mon projet',
  },
  s8: {
    title: 'Comment votre projet commence-t-il ?',
    step1: 'Partagez votre espace',
    step1d: 'Envoyez-nous les détails essentiels sur votre villa ou votre projet.',
    step2: 'Définir le besoin',
    step2d: 'Clarifions ensemble la capacité des véhicules et les scénarios d’utilisation.',
    step3: 'Approche de design',
    step3d: 'Développons une approche de design sur mesure adaptée à votre architecture.',
    step4: 'Devis',
    step4d: 'Fournissons un devis personnalisé selon l’étendue du projet.',
    step5: 'Mise en œuvre',
    step5d: 'Après validation, réalisons la mise en œuvre comme prévu.',
  },
  s9: {
    title: 'Projets de garage inspirants',
    filterAll: 'Tous',
    filterSingle: 'Une place',
    filterDouble: 'Deux places',
    filterVilla: 'Projets de villa',
    filterWinter: "Jardin d'hiver",
  },
  s10: {
    title: 'Concevons une solution sur mesure pour votre villa ou votre projet.',
  },
  form: {
    name: 'Nom complet',
    namePh: 'Votre nom complet',
    phone: 'Téléphone',
    phonePh: '+90 5xx xxx xx xx',
    email: 'E-mail',
    emailPh: 'exemple@email.com',
    city: 'Ville',
    cityPh: 'Votre ville',
    customerType: 'Type de client',
    solution: 'Solution qui vous intéresse',
    projectStatus: 'Statut du projet / terrain',
    message: 'Message',
    messagePh: 'Décrivez brièvement votre projet...',
    upload: "Téléversement d'image",
    uploadHint: 'Vous pouvez téléverser des images de terrain, de villa ou de référence',
    submit: 'ENVOYER MON PROJET',
    success: 'Votre demande a bien été reçue. Nous vous contacterons prochainement.',
    error: 'Une erreur est survenue. Veuillez réessayer.',
    customer: {
      villaOwner: 'Propriétaire de villa',
      construction: 'Entreprise de construction',
      developer: 'Promoteur',
      architect: 'Architecte',
      investor: 'Investisseur',
      other: 'Autre',
    },
    solutionOpt: {
      single: 'Garage une place',
      double: 'Garage deux places',
      villaProject: 'Projet de villa',
      winterGarden: "Jardin d'hiver",
      combined: "Garage + Jardin d'hiver",
      custom: 'Projet spécial',
    },
    status: {
      land: 'Terrain disponible',
      construction: 'Villa en construction',
      existing: 'Villa existante',
      none: 'Pas encore de terrain',
      other: 'Autre',
    },
  },
  whatsapp: {
    message: 'Bonjour VILLAGARAGE, je souhaite obtenir des informations et un devis pour mon projet de villa / garage.',
  },
  mobile: {
    cta: 'Demander des informations pour votre projet',
  },
  faq: {
    title: 'Questions fréquentes',
    q1: 'Peut-il être appliqué aux villas existantes ?',
    a1: 'Oui. Nous proposons des solutions adaptées aux villas neuves comme existantes. Pour les villas existantes, une mise en œuvre sur mesure est réalisée après évaluation de l’espace et de la structure architecturale.',
    q2: 'Existe-t-il des systèmes une et deux places ?',
    a2: 'Oui, nos systèmes de garage premium une et deux places sont disponibles. Nous développons également des solutions multiples sur mesure.',
    q3: 'Le même modèle est-il appliqué à chaque villa ?',
    a3: 'Non. Chaque projet est conçu sur mesure selon l’architecture, les dimensions et les besoins du client ; aucun modèle standard n’est utilisé.',
    q4: 'Travaillez-vous sur des projets multi-villas ?',
    a4: 'Oui, nous collaborons avec des entreprises de construction et des promoteurs sur des projets multi-villas, en proposant des solutions sur mesure.',
    q5: 'Un jardin d’hiver peut-il aussi être réalisé ?',
    a5: "Oui. En plus des systèmes de garage, nous proposons des solutions de jardin d'hiver et des solutions intégrées garage + jardin d'hiver.",
    q6: 'Comment le prix est-il déterminé ?',
    a6: 'Le prix est déterminé selon les dimensions, la capacité des véhicules, les détails architecturaux, les préférences de matériaux et l’étendue du projet.',
    q7: 'Comment puis-je soumettre mon projet ?',
    a7: 'Vous pouvez remplir le formulaire sur notre site, nous joindre via WhatsApp (+90 542 799 47 89) ou envoyer un message via Instagram (@villagarage90).',
  },
  about: {
    title: 'À propos',
    text: 'VILLAGARAGE est une marque qui développe des solutions architecturales pour les garages de villa premium et les espaces de vie extérieurs. Elle considère le garage non comme une structure indépendante mais comme une partie intégrante de l’architecture de la villa, apportant une valeur durable aux espaces de vie grâce aux systèmes anthracite, aux détails en bois naturel et aux designs de façade personnalisés. En collaboration avec les propriétaires, architectes, entrepreneurs et promoteurs, elle fournit des solutions premium sur mesure, intégrées à l’architecture.',
  },
  final: {
    title: 'Complétez l’architecture de votre villa avec votre garage.',
    cta1: 'Demander un devis pour votre projet',
    cta2: 'Nous contacter sur WhatsApp',
  },
  roles: {
    member: 'Membre Standard',
    dealer_a: 'Revendeur Classe A',
    dealer_b: 'Revendeur Classe B',
    dealer_c: 'Revendeur Classe C',
    distributor: 'Distributeur',
    architect: 'Architecte',
    construction: 'Entreprise de Construction',
    realtor: 'Agent Immobilier',
    admin: 'Administrateur',
  },
  catalog: {
    title: 'Systèmes de Garage',
    all: 'Tous',
    cat: {
      standard: 'Garages Standards',
      custom: 'Garages sur Mesure',
      luxury: 'Garages de Luxe',
    },
    tag: {
      new: 'Nouveau',
      single: 'Un Véhicule',
      double: 'Deux Véhicules',
      premium: 'Premium',
      project: 'Spécifique au Projet',
    },
    capacityLabel: 'Capacité Véhicules',
    singleCar: '1 Véhicule',
    doubleCar: '2 Véhicules',
    multiCar: 'Plusieurs Véhicules',
    quote: 'Demander un Devis',
    details: 'Détails',
    addToCart: 'Ajouter au Panier',
    projectQuote: 'Créer un Devis Spécifique au Projet',
    from: 'À partir de',
    priceOnRequest: 'Demandez un devis pour le prix',
    empty: 'Aucun produit dans cette catégorie pour le moment.',
    p1: { desc: 'Un garage premium compact, élégant et architecturalement sur mesure pour un seul véhicule.' },
    p2: { desc: 'Un garage premium spacieux et lumineux qui s’intègre parfaitement à votre villa pour deux véhicules.' },
    p3: { desc: 'Un garage une place conçu sur mesure pour votre villa et intégré à son architecture.' },
    p4: { desc: 'Une solution de garage architectural deux places au design personnalisé.' },
    p5: { desc: 'Un garage de villa de luxe avec des matériaux et des détails de très haut niveau.' },
    p6: { desc: 'Systèmes de garage sur mesure par projet pour les projets multi-villas.' },
  },
  currency: {
    label: 'Devise',
    planned: 'Bientôt',
  },
  auth: {
    title: 'Espace Membre / Revendeur',
    subtitle: 'Accédez à votre panneau et à vos tarifs selon votre rôle.',
    email: 'E-mail',
    password: 'Mot de passe',
    submit: 'Se connecter',
    note: "La connexion sécurisée et l'autorisation par rôle seront actives dès que la connexion au backend sera établie.",
    comingSoon: "La couche de connexion est prête. Cet écran deviendra actif dès que la connexion sécurisée au backend sera établie.",
    roleInfoTitle: 'Accès par Rôle',
    roleInfoText: "Les rôles membre standard, revendeurs Classe A/B/C, distributeur, architecte, entreprise de construction, agent immobilier et administrateur sont pris en charge. Chaque rôle ne voit que les zones autorisées ; l'autorisation est appliquée côté serveur.",
    applyCta: 'Postuler pour la concession & le partenariat',
    backHome: "Retour à l'accueil",
  },
  dealer: {
    badge: 'Réseau de Partenariat',
    heroTitle: 'Rejoignez le Réseau de Partenariat VILLAGARAGE',
    heroSubtitle: 'Apportez les systèmes de garage premium VILLAGARAGE à vos clients en Turquie et sur les marchés internationaux.',
    heroCta: 'Postuler',
    modelsTitle: 'Modèles de Membre & de Concession',
    modelsSubtitle: 'Une structure pour chaque niveau, du client individuel au revendeur professionnel.',
    cardCta: 'Infos Détaillées & Candidature',
    models: {
      standard: { name: 'Membre Standard', desc: 'Adhésion de base pour les clients individuels et les membres réguliers.' },
      a: { name: 'Concession Classe A', desc: "Le modèle de concession le plus complet. Remises, quota, garantie et avantages de paiement sont définis par l'administrateur." },
      b: { name: 'Concession Classe B', desc: 'Un modèle de partenariat équilibré pour les revendeurs de taille moyenne.' },
      c: { name: 'Concession Classe C', desc: "Un modèle de partenariat d'entrée de gamme pour les nouveaux revendeurs." },
    },
    proTitle: 'Partenariat Professionnel',
    proSubtitle: 'Un modèle de partenariat flexible pour les professionnels qui apportent des projets et des clients.',
    proSectors: 'Architectes • Entreprises de Construction • Agents Immobiliers • Distributeurs',
    partnerCta: 'Devenir Partenaire',
    partnersTitle: 'Modèles de Partenaire',
    partners: {
      distributor: 'Distributeur',
      architect: 'Architecte',
      construction: 'Entreprise de Construction',
      realtor: 'Agent Immobilier',
      other: 'Autre Partenaire',
    },
    partnersNote: 'Sans quota ni garantie de revendeur ; chaque groupe reçoit sa propre remise, son avantage tarifaire et son niveau de permission.',
    termsTitle: 'Conditions Spécifiques à la Classe',
    termsText: "Les taux de remise, les quotas d'achat, les montants de garantie et les avantages de paiement sont définis séparément pour chaque classe de concession et gérés depuis le panneau d'administration. Ces valeurs ne sont pas fixées pour le moment.",
    rolesTitle: 'Structure des Rôles',
    rolesSubtitle: "Chaque utilisateur ne voit que les zones autorisées par son rôle ; l'autorisation est appliquée côté serveur dès qu'un backend sécurisé est connecté.",
    form: {
      title: 'Formulaire de Candidature',
      subtitle: 'Remplissez le formulaire ci-dessous ; votre candidature sera reçue pour évaluation.',
      name: 'Nom Complet',
      company: 'Nom de la Société',
      phone: 'Téléphone',
      email: 'E-mail',
      country: 'Pays',
      city: 'Ville',
      website: 'Site Web',
      instagram: 'Instagram',
      field: "Domaine d'Activité",
      applicationType: 'Type de Candidature',
      selectPlaceholder: 'Sélectionner',
      howToWork: 'Comment souhaitez-vous travailler avec VILLAGARAGE ?',
      messagePh: 'Dites-nous brièvement...',
      submit: 'Envoyer ma candidature',
      success: 'Votre candidature a été reçue pour évaluation.',
      error: 'Une erreur est survenue. Veuillez réessayer.',
    },
  },
  footer: {
    tagline: 'Premium Garage Systems',
    navTitle: 'Menu',
    contactTitle: 'Contact',
    instagram: 'Instagram',
    copyright: 'Tous droits réservés.',
  },
};